import { LogoutOutlined, PauseCircleOutlined, RightOutlined, SettingOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Dropdown, Flex, Layout, Tooltip, Typography } from "antd";
import { Link, useMatch } from "react-router-dom";
import { logout } from "../api/allauth";
import { useHeader } from "../contexts/HeaderContext";
import { useSettings } from "../contexts/SettingsContext";
import { ROUTES } from "../routes";
import { destinationLabel } from "../viewLabels";
import ProgressBar from "./ProgressBar";

import styles from "./AppHeader.module.css";

const { Header } = Layout;

function AppHeader() {
    const { showPauseButton, progressRequested, journey } = useHeader();
    const { openSettings } = useSettings();
    const onPlan = useMatch(ROUTES.LEARNING_JOURNEY_PLAN);
    const showProgressBar = progressRequested && !onPlan;

    const userMenu = {
        items: [
            {
                key: "settings",
                label: "Settings",
                icon: <SettingOutlined />,
                onClick: openSettings,
            },
            {
                key: "logout",
                label: "Logout",
                icon: <LogoutOutlined />,
                onClick: async () => {
                    await logout();
                    window.location.href = ROUTES.ACCOUNT.LOGIN;
                },
            },
        ],
    };

    return (
        <Header className={styles.appHeader}>
            <Flex justify="space-between" align="center" style={{ height: "100%", position: "relative" }}>

                {/* Left Section: Logo & Title */}
                <Flex align="center" gap="small" className={styles.leftSection}>
                    <img src="/w5n-logo.svg" alt="WeLearn Logo" className={styles.headerLogo} />
                    {/* The chevron points right in both directions on purpose: the plan is a place
                        beside the activity, not a level above it. The destination word is rendered,
                        not a tooltip -- this is the only way back from the plan, including on touch. */}
                    {journey?.title ? (
                        <Link
                            to={onPlan ? `/t/${journey.id}` : `/t/${journey.id}/plan`}
                            className={styles.journeyTitleLink}
                        >
                            <span className={`${styles.journeyTitle} ${styles.hideOnSmall}`}>
                                {journey.title}
                            </span>
                            <RightOutlined className={styles.journeyTitleChevron} />
                            <span className={styles.journeyDestination}>
                                {onPlan ? destinationLabel(journey.viewType) : "Plan"}
                            </span>
                        </Link>
                    ) : (
                        <Typography.Title
                            level={3}
                            className={`${styles.headerTitle} ${styles.hideOnSmall}`}
                        >
                            WeLearn
                        </Typography.Title>
                    )}
                </Flex>

                {/* Center Section: Progress Bar (if visible) */}
                {showProgressBar && <ProgressBar />}

                {/* Right Section: Buttons */}
                <Flex className={styles.buttons} align="center" gap="small">
                    {showPauseButton && (
                        <Tooltip title="Pause session">
                            <Button
                                size="large"
                                color="orange"
                                variant="solid"
                                shape="circle"
                                href="/"
                                className={styles.headerButton}>
                                <PauseCircleOutlined className={styles.headerIcon} />
                            </Button>
                        </Tooltip>
                    )}
                    <Dropdown menu={userMenu} placement="bottomRight" arrow>
                        <Button size="large"
                            variant="solid"
                            shape="circle"
                            className={styles.headerButton}>
                            <UserOutlined className={styles.headerIcon} />
                        </Button>
                    </Dropdown>
                </Flex>
            </Flex>
        </Header>
    );
}

export default AppHeader;
